<template>
  <div class="container">
    <h1 class="page-title">CORE Loader - Category</h1>
    <div>
      <table class="data-table" id="mytable">
        <thead>
          <tr>
            <th>SN</th>
            <th>Category</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>

    <button
      class="form-button"
      style="background-color: green"
      v-if="!uploadingContent"
      @click.prevent="storeMeeting"
    >
      Submit
    </button>
    <p v-if="uploadingContent">uploading <span class="loader"></span></p>

    <label>Upload CSV File</label><br />
    <input
      type="file"
      class="bg-red-800 p-2 w-full mt-2 text-gray-200 hover:bg-red-900 border rounded-md"
      @change="handleFileUpload"
    />
  </div>
</template>

<script setup>
import { onMounted, ref, nextTick } from "vue";
import axios from "axios";
import $ from "jquery";
import "datatables.net";
import Swal from "sweetalert2";

const form = ref([]);
const csvfile = ref();
const uploadingContent = ref(false);
const url = ref();
let dataTableInstance = null;

const handleFileUpload = async (event) => {
    try {
        const file = event.target.files[0];
        csvfile.value = file;
        const formdata = new FormData();
        formdata.append('template', csvfile.value);

        const response = await axios.post(`${url.value}/api/v1/core/upload-services?param=service`, formdata);
        
        console.log('Full response:', response);
        console.log('Response data:', response.data);
        
        if (response.status === 200 || response.status == 201) {
            // Clear existing data
            form.value = [];
            
            // Process each item
            response.data.data.forEach((element) => {
                // Create a simple object with all properties
                const item = { ...element };
                
                // Add a generic 'service' property based on whatever is in the element
                if (!item.service) {
                    // Try to find any property that might contain service/category data
                    const possibleServiceKeys = Object.keys(element).filter(key => 
                        key.toLowerCase().includes('service') || 
                        key.toLowerCase().includes('category') ||
                        key.toLowerCase().includes('name')
                    );
                    
                    if (possibleServiceKeys.length > 0) {
                        item.service = element[possibleServiceKeys[0]];
                    } else if (Object.keys(element).length > 0) {
                        // Use the first property if we can't find a service-like one
                        item.service = element[Object.keys(element)[0]];
                    } else {
                        item.service = 'Unknown';
                    }
                }
                
                form.value.push(item);
            });
            
            console.log('Form data ready:', form.value);
            
            // Wait for next tick to ensure DOM is updated
            await nextTick();
            
            // Initialize or refresh DataTable
            initDataTable();
        }
    } catch (error) {
        console.error('Upload error:', error);
        Swal.fire({
            title: 'Error!',
            text: 'Failed to upload file: ' + error.message,
            icon: 'error'
        });
    }
};

const initDataTable = () => {
    // Destroy existing instance if it exists
    if (dataTableInstance) {
        dataTableInstance.destroy();
        dataTableInstance = null;
    }
    
    // Clear the table body
    $('#mytable tbody').empty();
    
    // Initialize DataTable
    dataTableInstance = $('#mytable').DataTable({
        data: form.value,
        columns: [
            { 
                data: null, 
                orderable: false,
                render: function(data, type, row, meta) {
                    return meta.row + 1;
                }
            },
            { 
                data: 'service',
                render: function(data, type, row) {
                    return data || row[Object.keys(row)[0]] || 'N/A';
                }
            }
        ],
        pageLength: 10,
        responsive: true,
        destroy: true, // Allows re-initialization
        retrieve: true
    });
};

const storeMeeting = async () => {
  uploadingContent.value = true;
  try {
    const { status } = await axios.post(
      `${url.value}/api/v1/core/save-services?param=service`,
      form.value
    );
    
    if (status === 200 || status === 201) {
      Swal.fire({
        title: "Success!",
        text: "Data Stored Successfully!",
        icon: "success",
        confirmButtonText: "Ok!",
      });
    }
  } catch (error) {
    Swal.fire({
      title: "Error!",
      text: "Failed to store data: " + error.message,
      icon: "error",
      confirmButtonText: "Ok!",
    });
  } finally {
    uploadingContent.value = false;
  }
};

const settings = ref();
const getUrl = () => {
  // If settings are available in localStorage, load them
  const storedSettings = localStorage.getItem("settings");
  if (storedSettings) {
    settings.value = JSON.parse(storedSettings);
    url.value = settings.value.defaultStates[0].budget;
  }
};

onMounted(() => {
  getUrl();
  // Initialize empty DataTable on mount
  initDataTable();
});
</script>

<style>
/* Add your CSS styles in a separate stylesheet or <style> block */
.container {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
}

.page-title {
  font-size: 24px;
  margin-bottom: 20px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid black;
}

.data-table th,
.data-table td {
  border: 1px solid black;
  padding: 10px;
  text-align: left;
}

.form-button {
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
}

.form-fields {
  margin-top: 20px;
}

.input-field {
  width: 40%;
  padding: 5px;
  margin: 5px 0;
  border: 1px solid #ccc;
}

.loader {
  width: 10px;
  height: 10px;
  border: 2px solid black;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.bg-red-800 {
  background-color: #991b1b;
}

.p-2 {
  padding: 0.5rem;
}

.w-full {
  width: 100%;
}

.mt-2 {
  margin-top: 0.5rem;
}

.text-gray-200 {
  color: #e5e7eb;
}

.hover\:bg-red-900:hover {
  background-color: #7f1d1d;
}

.border {
  border-width: 1px;
}

.rounded-md {
  border-radius: 0.375rem;
}
</style>